export function toRowSelectionState(items: { id: string }[]): Record<string, boolean> {
  return items.reduce<Record<string, boolean>>((acc, curr) => {
    return { ...acc, [curr.id]: true };
  }, {});
}
